export function autocomplete() {
	return ['1', '2']
}

export function predict(string) {
	const words = string.trim().toLowerCase().split(' ')
	const number = Number(words[0])

	if (words[0] && !Number.isNaN(number)) {
		return [String(number + 1)]
	}

	return []
}



// WEBPACK FOOTER //
// ./src/services/prediction/number.js